import {
  useGetBinderVerificationSummary,
  type BinderVerificationSummaryRow,
  type GetBinderVerificationSummaryParams,
  type GetBinderVerificationSummary200,
} from "@taxassist/api-client";

const POLLING_INTERVAL_MS = 30_000;
const MAX_POLLING_DURATION_MS = 30 * 60 * 1000;

function hasInFlightRow(rows: BinderVerificationSummaryRow[] | undefined): boolean {
  if (!rows) return false;
  return rows.some(
    (r) => r.pipelineStatus === "pending" || r.pipelineStatus === "processing",
  );
}

export function useBinderVerificationSummary(
  firmId: string | null | undefined,
  filter?: string,
) {
  const startedAt = Date.now();
  const params: GetBinderVerificationSummaryParams = {};
  if (filter && filter !== "all") {
    params.filter = filter as GetBinderVerificationSummaryParams["filter"];
  }

  const query = useGetBinderVerificationSummary(firmId ?? "", params, {
    query: {
      enabled: !!firmId,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      refetchInterval: (q: { state: { data?: GetBinderVerificationSummary200 } }) => {
        if (Date.now() - startedAt > MAX_POLLING_DURATION_MS) return false;
        return hasInFlightRow(q.state.data?.rows) ? POLLING_INTERVAL_MS : false;
      },
    },
  });

  return {
    rows: (query.data?.rows ?? []) as BinderVerificationSummaryRow[],
    count: query.data?.count ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
